import React from 'react';
// import DefaultUserAvatar from 'assets/svgs/common/default-avatar.svg';

export default ({item, calculatePositionOfStickyHeaders, config, index}) => (
  <td
    className={`name text-center ${index === 0 ? 'first-cell' : ''}`}
    style={{
      ...calculatePositionOfStickyHeaders(config),
      verticalAlign: 'middle',
    }}
  >
    <div>
      <img
        src={item.avatar || 'https://upload.jidipi.com/avatars/default.svg'}
        alt="Avatar"
        height={24}
        width={24}
        loading="lazy"
      />
      {`${item.firstName} ${item.lastName || ''}`}
    </div>
  </td>
);
